import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const TableChoiceWaypoints = ({items, itemsShown}) => {
    const handleClickRow = (e) => {
        let checked, value, checkbox;
        if (e.target.type === "radio") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector("input[type='radio']");
            checkbox.checked = !checkbox.checked;
        }
        checked = checkbox.checked;
        value = parseInt(checkbox.value);
        items.current.chosen = [value];
    }
    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th style={{width: "26px"}}></th>
                <th>Referencia</th>
            </tr>
            </thead>
            <tbody>
            {itemsShown.map((item, index) => (
                <tr key={index} data-idx={index} className="cursor-pointer" onClick={handleClickRow} style={{cursor: "pointer"}}>
                    <td>
                        <input
                            type="radio" name="radio-waypoint"
                            value={index}
                            defaultChecked={items.current.chosen.includes(index)}
                        />
                    </td>
                    <td><FontAwesomeIcon icon={item.icon} className="text-secondary me-2"/> {item.name}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default TableChoiceWaypoints

